/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_History_EmptyInputs */

const en_us2_plan_history_empty = /** @type {(inputs: Plan_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No changes to your plan yet.`)
};

const pt_br2_plan_history_empty = /** @type {(inputs: Plan_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma mudança no seu plano ainda.`)
};

const es_419_plan_history_empty = /** @type {(inputs: Plan_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay cambios en tu plan.`)
};

const pt_pt2_plan_history_empty = /** @type {(inputs: Plan_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não há alterações no teu plano.`)
};

const fr_fr2_plan_history_empty = /** @type {(inputs: Plan_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun changement dans ton programme pour l'instant.`)
};

const de_de2_plan_history_empty = /** @type {(inputs: Plan_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Änderungen an deinem Plan.`)
};

const it_it2_plan_history_empty = /** @type {(inputs: Plan_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna modifica alla tua scheda.`)
};

/**
* | output |
* | --- |
* | "No changes to your plan yet." |
*
* @param {Plan_History_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_history_empty = /** @type {((inputs?: Plan_History_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_History_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_history_empty(inputs)
	if (locale === "es-419") return es_419_plan_history_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_history_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_history_empty(inputs)
	if (locale === "de-DE") return de_de2_plan_history_empty(inputs)
	if (locale === "it-IT") return it_it2_plan_history_empty(inputs)
	return en_us2_plan_history_empty(inputs)
});
export { plan_history_empty as "plan.history_empty" }